<template>
  <div class="avatar-box relative" :style="style">
    <el-image
      :src="value | httpsAvatar"
      class="avatar"
      :style="style"
      fit="cover"
    >
      <div slot="placeholder" class="avatar-placeholder" :style="style">
        <i class="el-icon-picture-outline"/>
      </div>
      <div slot="error" class="avatar-placeholder" :style="style">
        <i class="el-icon-picture-outline"/>
      </div>
    </el-image>
    <el-image
      :src="value | httpsAvatar"
      v-if="isShowShadow"
      class="avatar avatar-shadow"
      :style="style"
      fit="cover"
    >
      <div slot="placeholder" class="avatar-placeholder" :style="style">
        <i class="el-icon-picture-outline"/>
      </div>
      <div slot="error" class="avatar-placeholder" :style="style">
        <i class="el-icon-picture-outline"/>
      </div>
    </el-image>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: '',
    },
    size: {
      type: Number,
      default: 0,
    },
    ratio: {
      type: Number,
      default: 1,
    },
    radius: {
      type: String,
      default: '',
    },
    isShowShadow: Boolean,
  },
  computed: {
    style() {
      let sizeStyle = '';
      let radiusStyle = '';
      const { size, ratio, radius } = this;
      if (size) sizeStyle = `width: ${size * ratio}px;height: ${size}px;`;
      if (radius) radiusStyle = `border-radius: ${radius};`;
      return `${sizeStyle}${radiusStyle}`;
    }
  }
};
</script>

<style scoped>
.avatar-box {
  border-radius: 50%;
}

.avatar {
  object-fit: cover;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  border-radius: 50%;
}

.avatar-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  font-size: 35px;
  background: #f5f5f5;
  color: #e4e6e6;
  border-radius: 50%;
}

.avatar-shadow {
  top: 10%;
  left: 0;
  z-index: 1;
  filter: blur(10px) opacity(0.9);
  border-radius: 50%;
}

/deep/.el-image {
  overflow: inherit;
}

/deep/.el-image__inner {
  border-radius: inherit;
}
</style>
